import React from 'react';
import { P, match } from 'ts-pattern';
import { GitHubFileIcon } from '../../github/components/Icons/GitHubFileIcon';
import ChatCodeBlock from '../chat-codeblock';
import ChatMessagePartToolContainer from './chat-message-part-tool-container';
import type { ChatMessagePartToolBaseProps } from './types';

export type ChatMessagePartToolGitHubContentsFileReadProps =
  ChatMessagePartToolBaseProps<'github-contents-file-read'>;

function ChatMessagePartToolGitHubContentsFileRead({
  toolInvocation,
  compact,
  defaultOpen,
  card,
  onEngage,
}: ChatMessagePartToolGitHubContentsFileReadProps) {
  return match(toolInvocation)
    .with(
      { state: 'result', result: { status: 'success' } },
      ({ result: { result }, args }) => {
        const fileExtension = args.filePath.split('.').pop() ?? 'txt';
        return (
          <ChatMessagePartToolContainer
            icon={<GitHubFileIcon fileExtension={fileExtension} />}
            title={`${args.filePath}`}
            status='result'
            compact={compact}
            defaultOpen={defaultOpen}
            card={card}
            onToggle={() => {
              onEngage?.('engage');
            }}
          >
            <ChatCodeBlock code={result} filePath={args.filePath} />
          </ChatMessagePartToolContainer>
        );
      }
    )
    .with({ state: 'result', result: { status: 'error' } }, () => null)
    .otherwise(() => {
      return (
        <ChatMessagePartToolContainer
          icon={<GitHubFileIcon />}
          card={card}
          title='Reading file content...'
          status='loading'
        />
      );
    });
}

export default React.memo(ChatMessagePartToolGitHubContentsFileRead);
